import * as React from 'react';
import { CheckboxState } from '../../components/checkboxes/CheckboxState';

export const CHECKBOX_CLASS: string = 'tb-checkbox ';
export const CHECKED: string = 'tb-checked ';
export const EMPTY: string = 'tb-empty ';
export const MIXED: string = 'tb-mixed ';
export const DISABLED: string = 'tb-disabled';

export class ReactCheckboxTristate extends React.PureComponent<ReactCheckboxTristate.Props, {}> {

  public render() {
    let checkboxState: string = this.getCheckboxState();

    /* eslint-disable jsx-a11y/no-static-element-interactions */
    /* eslint-disable jsx-a11y/click-events-have-key-events */
    return (
      <div>
        <span className={this.getCheckboxState()} onClick={(e) => {this.props.clicked();}}></span>
        <span className="tb-label" onClick={() => this.props.clicked()}> {this.props.label} </span>
      </div>
    );
  }

  public getCheckboxState(): string {
    let checkboxClassState: string = CHECKBOX_CLASS;

    switch(this.props.checkboxState){
      case CheckboxState.checked:
        checkboxClassState += CHECKED;
        break;
      case CheckboxState.empty:
        checkboxClassState += EMPTY;
        break;
      default:
        checkboxClassState += MIXED;
        break;
    }

    if (this.props.disabled) {
      checkboxClassState += DISABLED;
    }

    return checkboxClassState;
  }
}

export namespace ReactCheckboxTristate {

  export interface Props {
    readonly checkboxState: CheckboxState;
    readonly clicked: () => void;
    readonly disabled: boolean;
    readonly label?: string;
  }
}
